import React from 'react';
import { useContext } from 'react';
import classNames from 'classnames';
//import ReactPropTypes from 'prop-types';

import { FormContext } from './Form';

export function FormSubmit({
    as: Component = "button",
    onClick,
    children,
    dirty,
    ignoreDirty = false,
    ...rest
}) {

    const { 
        current, formIsDirty, formDisabled, formReadOnly,
    } = useContext(FormContext);

    //
    // All the caller to provide an overriding set of "dirty" parameters to use 
    //  when the formIsDirty.
    //
    const params = formIsDirty ? {...rest, ...dirty} : {...rest};

    //
    // Extract specific parameters and allow the rest to passThru
    //
    const { disabled, className } = params;
    const filterParams = ({ disabled, className, ...remainder }) => remainder;
    const passThru = filterParams(params);

    //
    // The submit button should be disabled if 
    //  the button or form is disabled 
    //  or the form is read-only
    //  or the form is not dirty yet (nothing to save) - may want to add a param to always enable?
    //
    const currDisabled = disabled || formDisabled || formReadOnly || (!formIsDirty && !ignoreDirty);

    const elementClass = classNames(
        'form-btn',
        'form-submit',
        className,
        { 'is-dirty': formIsDirty }
    );

    return(
        <Component 
            className={elementClass} 
            disabled={currDisabled}
            onClick={() => onClick(current)}
            {...passThru}
        >
            {children}
        </Component>
    )
}

export function FormReset({
    as: Component = "button",
    onClick,
    children,
    dirty,
    ...rest
}) {

    const { 
        formIsDirty, defaultReset
    } = useContext(FormContext);

    //
    // All the caller to provide an overriding set of "dirty" parameters to use 
    //  when the formIsDirty.
    //
    const params = formIsDirty ? {...rest, ...dirty} : {...rest};

    //
    // Extract specific parameters and allow the rest to passThru
    //
    const { className } = params;
    const filterParams = ({ className, ...remainder }) => remainder;
    const passThru = filterParams(params);


    const elementClass = classNames(
        'form-btn',
        'form-reset',
        className,
        { 'is-dirty': formIsDirty }
    );

    return(
        <Component 
            className={elementClass} 
            onClick={() => defaultReset(onClick)}
            {...passThru}
        >
            {children}
        </Component>
    )
}

